import { BreadCrumbsInterface } from '../interface/interface';

export function generateSearchBreadcrumbs(state: any) {
  const items: Array<BreadCrumbsInterface> = [];

  if (state?.brandValue) {
    items.push(
      { tag: 'p', className: 'mr-3', children: <span>Brand</span> },
      {
        tag: 'p',
        className: 'mr-3',
        children: <span>{state.brandValue}</span>,
      },
    );
  }

  if (state?.activeCategory) {
    items.push(
      { tag: 'p', className: 'mr-3', children: <span>Products</span> },
      {
        tag: 'p',
        className: 'mr-3',
        children: <span>{state.activeCategory}</span>,
      },
    );
  }

  if (state?.activeFormulation) {
    items.push({
      tag: 'p',
      className: 'mr-3',
      children: <span>{state.activeFormulation}</span>,
    });
  }

  if (state?.area) {
    items.push({
      tag: 'p',
      className: 'mr-3',
      children: <span>{state.area}</span>,
    });
  }

  return items;
}
